// extracted by mini-css-extract-plugin
export default {"setup-card":"Card_setup-card__GhNPq","card-alert":"Card_card-alert__YsODV"};